import styled from "styled-components";

export const Description = styled.div`
  color: white;

  img {
    margin-bottom: 10px;
  }
`;
